import { api as gridApi} from './qplsViewGridActions';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';
import {api as messageDialogApi} from '../../MessageDialog/messageDialogActions';
import * as qplsService from '../../../services/Qpls/qplsService';
import Network from 'infrastructure/js/modules/network';
import {api as updateMaterialQplVersionDialogApi} from './Dialogs/updateMaterialQplVersionDialogActions';
import {api as exportApi} from '../../Export/exportActions';
import {headerItemsLabels} from '../../../components/Common/Header/header';
/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {
};

////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
const actions = {
};

/////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {};

jsxActions.init = function(shouldRefreshGrid) {
  return function(dispatch, getState) {
    api.load(dispatch, getState)(shouldRefreshGrid);
  }
};

jsxActions.reload = function() {
  return function(dispatch, getState) {
    api.reload(dispatch, getState)();
  }
};

jsxActions.clearFilters = function () {
  return function (dispatch, getState) {
    gridApi.clearFilters(dispatch, getState)();
  }
};

jsxActions.removeQpl = function(data) {
  return function(dispatch, getState) {
    api.removeQpl(dispatch, getState)(data);
  }
};

jsxActions.activateQpl = function(data) {
  return function(dispatch, getState) {
    api.activateQpl(dispatch, getState)(data);
  }
};

jsxActions.exportQpl = function(qplId) {
  return function(dispatch, getState) {
    exportApi.exportQpl(dispatch, getState)(qplId);
  }
};

/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
export let api = {};

api.load = function(dispatch, getState) {
  return function(shouldRefreshGrid) {
    if (shouldRefreshGrid) {
      gridApi.reload(dispatch, getState)();
    }
  }
};

api.reload = function(dispatch, getState) {
  return function() {
      gridApi.reload(dispatch, getState)();
  }
};

api.removeQpl = function(dispatch, getState) {
  return function (data) {

    let labels = createLabelHelper('mat.administration.matsettings.qpls.view.');
    let confirmationConfig = {
      message: labels.get('remove.confirmation.message', '', {count: 1}),
      submitButtonLabel: headerItemsLabels.DELETE,
      cancelHandler: messageDialogApi.close(dispatch, getState),
      submitHandler: () => api.doRemoveQpl(dispatch, getState)(data),
    };

    messageDialogApi.showConfirmation(dispatch, getState)(confirmationConfig);
  }
};

api.doRemoveQpl = function(dispatch, getState) {
  return function(data) {
    messageDialogApi.close(dispatch, getState)();

    qplsService.removeQpl(data).then((response) => {
      if (!Network.isResponseValid(response)) {
        console.error('Failed to remove QPL', response);
        messageDialogApi.responseError(dispatch, getState)(response);
        return {success: false};
      }
      gridApi.reload(dispatch, getState)();
    });
  }
};

api.activateQpl = function(dispatch, getState) {
  return function (data) {
    qplsService.activateQpl(data).then((response) => {
      if (!Network.isResponseValid(response)) {
        console.error('Failed to activate QPL', response);
        messageDialogApi.responseError(dispatch, getState)(response);
        return {success: false};
      }
      gridApi.reload(dispatch, getState)();

      if (response.data?.materials?.length ) {
        updateMaterialQplVersionDialogApi.show(dispatch, getState)(
          {
            materials: response.data?.materials ?? [],
            qplId: response.data.qpl?.id,
          });
      }
    });
  }
}



/////////////////////////////////////////////////////////////////////////
// PRIVATE HELPERS
